import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=084c5c54&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=084c5c54&prod&lang=scss&scoped=true"
import style1 from "./nav.vue?vue&type=style&index=1&id=084c5c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c5c54",
  null
  
)

export default component.exports